import React, { memo, useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  Tooltip,
  IconButton,
  Grid,
  FormControl,
  InputLabel,
  NativeSelect,
  TextField,
  InputAdornment,
  Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useSelector } from 'react-redux';
import configServ from '../../../services/config';

//FUNCTION
const CategoryTable = ({ handleEdit, isChanged, pagination = true }) => {
  //#region code
  const { company_id } = useSelector((state) => state.GlobalVariables);
  const rowsPerPageOptions = [25, 100, 200, 500];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [searchBy, setSearchBy] = useState('categoryname');
  const [search, setSearch] = useState('');
  const [categoryList, setCategoryList] = useState([])
  //const [filterCategoryList, setFilterCategoryList] = useState([])
  const [count, setCount] = useState(0)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const fetchCategory = async () => {
    try {
      const dataToSend = {
        "company_id": company_id,
        "search_by": searchBy,
        "search": search,
        "per_page": rowsPerPage,
        "page": page
      }
      const res = await configServ.getcategory(dataToSend);
      if (res.status === 200) {
        setCategoryList(res.data);
        //setFilterCategoryList(res.data);
        setCount(res.total);
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [isChanged, page, rowsPerPage, search])


  const headers = ['CATEGORY NAME', 'DESCRIPTION', 'STATUS', 'DEFAULT SELECTED', 'ACTION'];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  // const paginatedData = pagination
  //   ? filterCategoryList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  //   : filterCategoryList;

  const headerCellStyle = {
    fontSize: 14, // Adjust the font size as needed
    fontWeight: 'bold',
    backgroundColor: 'black', // Set the header background color to blue
    color: 'white',
  };

  const evenRowStyle = {
    background: '#f5f5f5',
  };

  const oddRowStyle = {
    background: 'white',
  };

  const rowStyle = {
    '&:hover': {
      background: '#f1f9fe',
    },
  };

  const handleSearchBy = (event) => {
    try {
      setSearchBy(event.target.value);
    }
    catch (error) {
      console.log(error);
    }
  }

  const handleSearch = (event) => {
    try {
      const data = event.target.value;
      if (data === "") {
        setSearch(null);
      }
      else {
        setSearch(data);
      }
    }
    catch (error) {
      console.log(error);
    }
  }
  //#endregion

  return (
    <>
      {/* search starts here */}
      <Grid container alignItems="flex-end" justifyContent="flex-start" style={{ padding: 10, paddingTop: 0 }} spacing={1} direction={'row'}>
        <Grid item xs={12} md={6} ml={0} justifyContent={'flex-start'}>
          <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>Category List:{count}</Typography>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box sx={{ minWidth: 120, marginLeft: '10px' }}>
            <FormControl
              fullWidth
            >
              <InputLabel variant="standard" htmlFor="uncontrolled-native">
                Search By
              </InputLabel>
              <NativeSelect

                onChange={handleSearchBy}
                inputProps={{
                  name: 'searchBy',
                  id: 'uncontrolled-native',
                }}
              >
                <option value={'categoryname'}>Category Name</option>
              </NativeSelect>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={3} mr={{ xs: 0, md: 0 }} justifyContent={'flex-end'}>
          <TextField
            id="outlined-basic"
            size="small"
            fullWidth
            placeholder="search"
            variant="outlined"
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fill: 'grey' }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      {/* search ends here */}

      <TableContainer component={Paper} sx={{ px: 0 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {/* <TableCell style={headerCellStyle}>
              <IconButton disabled>
                <VisibilityIcon />
              </IconButton>
            </TableCell> */}
              <TableCell style={headerCellStyle}>Sr. No.</TableCell>
              {headers.map((header, index) => (
                <TableCell key={index} style={headerCellStyle}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {categoryList.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  ...rowStyle,
                  ...(rowIndex % 2 === 0 ? evenRowStyle : oddRowStyle),
                }}
              >
                {/* <TableCell style={iconCellStyle}>
                <Tooltip title='View details' arrow>
                    <IconButton onClick={()=>{handleNestedTable(row.id)}}>
                        <VisibilityIcon color='primary'  />
                    </IconButton>
                </Tooltip>
            </TableCell> */}
                <TableCell>{page * rowsPerPage + rowIndex + 1}</TableCell>
                <TableCell>{row.categoryname}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.status === 1 ? <CheckCircleIcon color='success' /> : <CancelIcon color='error' />}</TableCell>
                <TableCell>{row.isPrimary === 1 ? <CheckCircleIcon color='success' /> : <CancelIcon color='error' />}</TableCell>
                <TableCell>
                  <div>
                    <Tooltip title='Edit' arrow>
                      <IconButton onClick={() => { handleEdit(row); scrollToTop() }}>
                        <EditIcon color='primary' />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
            {/* {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={headers.length + 2} />
              </TableRow>
            )} */}
          </TableBody>
        </Table>
        {pagination && (
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </TableContainer>
    </>
  );
};

export default memo(CategoryTable);
